import './styles/app.scss';
import { useEffect } from 'react';
import { HashRouter, Switch, Route, Redirect, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { IconRegistryProvider } from '@rig/rw-core-components';
import { tourRouteNames, TourRoutePath } from './static/routes';
import { Tours } from './components/tours/Tours';

const RouteController = ({ children }) => {
  const { t, i18n } = useTranslation();
  const location = useLocation<{ samePage: boolean }>();

  useEffect(() => {
    if (location.state?.samePage) return;
    const matchedPaths = Object.values(TourRoutePath).filter((val) =>
      tourRouteNames[val] && new RegExp(`${val}(/|$)`, 'i').test(location.pathname));
    if (!matchedPaths.length) return;
    matchedPaths.sort((a, b) => b.length - a.length);
    const path = matchedPaths[0];

    if (process.env.NODE_ENV === 'production') {
      window.dataLayer.push({
        'event': 'VirtualPageview',
        'vpvURL': `/vpv/ReactUI${path}`,
        'vpvName': tourRouteNames[path],
        'language': i18n.language.toUpperCase()
      });
    }

    document.title = `${t(`title.${path.slice(1).toLowerCase().replace(/\//g, '.')}`)} - ${t('direct_investing')}`;
  }, [location]);

  return <Switch>{children}</Switch>;
};

export const ToursApp = () => {
  return (
    <IconRegistryProvider value={{ type: 'path', assetPath: process.env.PUBLIC_URL }}>
      <HashRouter>
        <RouteController>
          <Route path={`/Tours/:tourId/:step?`}>
            <Tours isPublicTour={true} />
          </Route>
          <Redirect to={`${TourRoutePath.Tours_Featured}/1`} />
        </RouteController>
      </HashRouter>
    </IconRegistryProvider>
  );
};
